import React from 'react';
import { useEffect, useState, useRef } from "react";
import {Col, Row, Card, CardBody, Modal, ModalHeader, ModalBody, ModalFooter, Button} from 'reactstrap';
import { useMediaQuery } from 'react-responsive';
import { APILA } from "../../../../../config/apila";
import { APIMS } from "../../../../../config/apims";
import { APIUS } from "../../../../../config/apius";
import { APISD } from "../../../../../config/apisd";
import ReactPaginate from "react-paginate";
import "bulma/css/bulma.css";
import "../../../../../index.css";
import swal from "sweetalert";
import LoaderHome from "../../../../Loader/LoaderHome";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { faGauge } from '@fortawesome/free-solid-svg-icons';
import axios from "axios";
import { Autosave, useAutosave } from 'react-autosave';
import ToastError from "../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../NotificationToast/ToastSuccess";
import Select from 'react-select';
import Chart from 'react-apexcharts';
const formatDateISO = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const subtractDays = (date, days) => {
  const next = new Date(date);
  next.setDate(next.getDate() - days);
  return next;
};
// import ModalRapor from './modal/rapor';

export default function Home() {
  document.title = "Dashboard";
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(1000);
  const [ascending, setAscending] = useState(1);
  const [descending, setDescending] = useState(0);
  const [keyword, setKeyword] = useState("");
  const [query, setQuery] = useState("");
  const token = localStorage.getItem("token");

  // Responsive to mobile or dekstop
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 780px)'});
  const [loading, setLoading] = useState(false);
  const storageBranchGroping = localStorage.getItem('ysb_branch_id');
  const storageLevel = localStorage.getItem('level');
   
  // Data
  const [storageBranch, setStorageBranch] = useState("");
  const [storageSchool, setStorageSchool] = useState("");
  const [storageTeacher, setStorageTeacher] = useState("");
  const [getDataDimensi, setGetDataDimensi] = useState([]);
  const [getDataDimensiDefault, setGetDataDimensiDefault] = useState([]);
  const [getDataSemester, setGetDataSemester] = useState([]);
  const [getDataSemesterMap, setGetDataSemesterMap] = useState([]);
  const [getDataBranch, setGetDataBranch] = useState([]);
  const [getDataSchool, setGetDataSchool] = useState([]);
  const [getDataTeacher, setGetDataTeacher] = useState([]);
  const [getDataGradeLevel, setGetDataGradeLevel] = useState([]);
  const [getDataKelas, setGetDataKelas] = useState([]);
  const [selectedGradeLevel, setSelectedGradeLevel] = useState("");
  const [selectedKelas, setSelectedKelas] = useState("");
  const [selectKey, setSelectKey] = useState(0);
  const [getData, setGetData] = useState([]);
  // Data untuk attendance dashboard
  const [attendanceItems, setAttendanceItems] = useState([]);
  const [attendanceStats, setAttendanceStats] = useState({
    total_siswa: 0,
    total_school_days: 0,
    total_hadir: 0,
    total_sakit: 0,
    total_izin: 0,
    total_alpa: 0,
    total_terlambat: 0,
    persentase_kehadiran: 0
  });
  const [startDate, setStartDate] = useState(formatDateISO(subtractDays(new Date(), 30)));
  const [endDate, setEndDate] = useState(formatDateISO(new Date()));
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [selectedGroupLabel, setSelectedGroupLabel] = useState("");
  const [selectedTab, setSelectedTab] = useState(null);
  const storageSchoolId = localStorage.getItem('ysb_school_id');
  const [pages, setPages] = useState(1);

  const [lowItems, setLowItems] = useState([]);
  const [studentsLow, setStudentsLow] = useState([]);
  const [studentsAll, setStudentsAll] = useState([]);
  const [onlyLow, setOnlyLow] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [selectedIndicators, setSelectedIndicators] = useState([]);

  const [namaTA, setNamaTA] = useState([]);
  const [namaSmstr, setNamaSmstr] = useState([]);
  const [isInitialized, setIsInitialized] = useState(false);

  // Filter management untuk button Cari
  const [isFilterDirty, setIsFilterDirty] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);

  const location = useLocation();
  const [permission, setPermission] = useState({
    create: 0,
    read: 0,
    update: 0,
    delete: 0
  });

  const navigate = useNavigate();
  useEffect(() => {
    const storageLevel = localStorage.getItem('level');
    const storageItems = JSON.parse(localStorage.getItem('role_permission')) || [];
    if (storageLevel === "developer" || storageLevel === "superadmin") {
      setPermission({
        create: 1,
        read: 1,
        update: 1,
        delete: 1
      });
    } else {
      const foundPermission = storageItems.find(item => item.menu?.url === location.pathname);
      if (!foundPermission) { 
        navigate('/dashboard');
      } else {
        setPermission({
          create: foundPermission.create,
          read: foundPermission.read,
          update: foundPermission.update,
          delete: foundPermission.delete
        });
      }}
  }, [location.pathname]);

  useEffect(() => {
    setStorageBranch(localStorage.getItem('ysb_branch_id') || "");
    setStorageSchool(localStorage.getItem('ysb_school_id') || "");
    setStorageTeacher(localStorage.getItem('teacherID') || "");
  }, [])

  const [form, setForm] = useState({
    ysb_semester_id: "",
    ysb_dimensi_id: "",
    ysb_branch_id: "",
    ysb_school_id:"",
    // ysb_teacher_id: ""
  });

  const [form2, setForm2] = useState({
    ysb_semester_id: "",
    ysb_dimensi_id: "",
    ysb_branch_id: "",
    ysb_school_id:"",
    // ysb_teacher_id: "",
    ysb_sub_element_value:"",
  });

   const [form3, setForm3] = useState({
    ysb_element_recap_id_id:"",
    ysb_sub_element_value:"",
  });

 

  let fetchParams = {
    headers : {"Authorization" : `${token}`,"Content-Type" : "application/json"}
  };

  const dashboardAutoFetchedRef = useRef(false);
  const raporAutoFetchedRef = useRef(false);
  const lastFetchParamsRef = useRef(null);

  const fetchDataRef = useRef();
  const fetchData = async () => {
    try {
      // setLoading(true);
      const [ dataSemester, dataDimensi] = await axios.all([
        // APILA.get(`/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,fetchParams),
        APIMS.get(`/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,fetchParams),
        APILA.get(`/api/access/dimensis?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}`,fetchParams),
      ]);
      if (dataSemester.status === 200  && dataDimensi.status === 200 ){
        const semesters = dataSemester.data.data.find(s => s.status === 1);
        // setGetDataBranch(dataBranch.data.data);
        setGetDataSemester(semesters);
        setGetDataSemesterMap(dataSemester.data.data);
        setGetDataDimensi(dataDimensi.data.data);
        setGetDataDimensiDefault(dataDimensi.data.data[0]);
        setNamaTA(semesters.name_year);
        setNamaSmstr(semesters.semester);
        // setLoading(false);
      }
    } catch (error) {
      // setLoading(false);
      swal({
        title: 'Failed',
        text: `${error.response.data.message}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    }
  };
  
  useEffect(() => {
    fetchDataRef.current = fetchData;
    fetchDataRef.current();
  }, []);

  // Fetch Grade Levels and Kelas for dropdown filters
  // Fetch Tingkatan berdasarkan ysb_school_id, Kelas berdasarkan tingkatan
  const fetchGradeLevelsAndKelas = async () => {
    try {
      const [gradeResponse, kelasResponse] = await axios.all([
        APIMS.get(`/api/grade-levels?page=1&limit=1000&ascending=1`, {
          ...fetchParams,
          params: { ysb_school_id: storageSchoolId }
        }),
        APIMS.get(`/api/access/kelas?page=1&limit=1000&ascending=1&search=`, {
          ...fetchParams,
          params: { ysb_school_id: storageSchoolId }
        })
      ]);

      if (gradeResponse.status === 200 && kelasResponse.status === 200) {
        const gradeLevels = gradeResponse.data.data || [];
        const kelasList = kelasResponse.data.data || [];
        
        setGetDataGradeLevel(gradeLevels);
        setGetDataKelas(kelasList);

        // Set default kelas to first item (batch updates to prevent multiple renders)
        if (kelasList.length > 0) {
          const firstKelas = kelasList[0];
          // Batch state updates using React.startTransition or set in sequence
          // React 18 automatically batches, but we'll be explicit
          if (firstKelas.ysb_grade_level_id) {
            setSelectedGradeLevel(firstKelas.ysb_grade_level_id);
          }
          // Set kelas last so useEffect only triggers once when both are ready
          setSelectedKelas(firstKelas.id);
        }
      }
    } catch (error) {
      console.error('Failed to fetch grade levels or kelas:', error);
    }
  };

  useEffect(() => {
    if (storageSchoolId) {
      fetchGradeLevelsAndKelas();
    }
  }, [storageSchoolId]);

  useEffect(() => {
    const first = getData?.[0]?.data_element?.[0]?.name_description;
    if (first) setSelectedTab(prev => prev || first);
  }, [getData]);

  const GetResponseData = async () => {
    try {
      setLoading(true);

      const params = {
        ysb_semester_id: form?.ysb_semester_id || getDataSemester?.id,
        ysb_branch_id: storageBranch,
        ysb_school_id: storageSchoolId,
        ysb_grade_level_id: selectedGradeLevel,
        ysb_kelas_id: selectedKelas,
        start_date: startDate,
        end_date: endDate
      };

      console.log('🔍 GetResponseData params:', params);

      const response = await APISD.get('/api/absen-dashboards/head', {
        params,
        ...fetchParams
      });

      console.log('✅ API Response:', response.data);

      if (response?.status === 200) {
        const respSummary = response.data?.summary || {};
        const respItems = response.data?.items || [];

        console.log('📊 Items from backend:', respItems.length, respItems);

        // ✅ Set attendance stats
        setAttendanceStats({
          total_siswa: respSummary.total_siswa || 0,
          total_school_days: respSummary.total_school_days || 0,
          total_hadir: respSummary.total_hadir || 0,
          total_sakit: respSummary.total_sakit || 0,
          total_izin: respSummary.total_izin || 0,
          total_alpa: respSummary.total_alpa || 0,
          total_terlambat: respSummary.total_terlambat || 0,
          persentase_kehadiran: respSummary.persentase_kehadiran || 0
        });

        // ✅ Set items (per-kelas data)
        setAttendanceItems(respItems);

        setLoading(false);
        dashboardAutoFetchedRef.current = true;
        lastFetchParamsRef.current = {
          semester: params.ysb_semester_id,
          branch: params.ysb_branch_id,
          school: params.ysb_school_id,
          gradeLevel: params.ysb_grade_level_id,
          kelas: params.ysb_kelas_id
        };

        console.log('✅ Dashboard loaded successfully');
      }

    } catch (error) {
      setLoading(false);
      swal({
        title: 'Failed',
        text: `${error.response?.data?.message || error.message}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    }
  };

  const GetResponseData2 = async () => {
    try {
      setLoading(true);
      const response = await APILA.get('/api/dashboards-head', {
        params: {
          level: storageLevel,
          branch: storageBranch,
          ysb_semester_id: form2?.ysb_semester_id,
          // ysb_dimensi_id: form2?.ysb_dimensi_id,
          ysb_school_id: form2?.ysb_school_id || storageSchoolId,
          // ysb_teacher_id: form2?.ysb_teacher_id || storageTeacher
        },fetchParams
      });

      if (response?.status === 200) {
        // setGetRapor(response.data.data || []);
        setPages(response.data.totalPage || 1);
        setLoading(false);
      }

    } catch (error) {
      setLoading(false);
      swal({
        title: 'Failed',
        text: `${error.response?.data?.message}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    }
  };

  const handleChange = (e) => {
    setForm2({
      ...form2,
      [e.target.name]: e.target.value,
    });
  };

  const handleInputChange2 = (e) => {
    setForm2({
      ...form2,
      ysb_teacher_id: e.value,
    });
  };

  useEffect(() => {
    if (storageBranch !== "") {
      setForm2(prevForm => ({
        ...prevForm,
        ysb_branch_id: storageBranch
      }));      
    }
  }, [storageBranch]);

  useEffect(() => {
    if (storageSchool) {
      setForm2(prev => ({ ...prev, ysb_school_id: storageSchool }));
    }
    if (storageTeacher) {
      setForm2(prev => ({ ...prev, ysb_teacher_id: storageTeacher }));
    }
  }, [storageSchool, storageTeacher]);

  useEffect(() => {
  }, [form2?.ysb_semester_id, form2?.ysb_dimensi_id]);

  useEffect(() => {
    if (getDataSemester?.id && getDataDimensiDefault?.id && !isInitialized) {
      
      setForm({
        ysb_semester_id: getDataSemester.id,
        ysb_dimensi_id: getDataDimensiDefault.id,
        ysb_branch_id: storageBranch,
        ysb_school_id: storageSchoolId,
        ysb_teacher_id: storageTeacher
      });

      setForm2({
        ysb_semester_id: getDataSemester.id,
        ysb_dimensi_id: getDataDimensiDefault.id,
        ysb_branch_id: storageBranch,
        ysb_school_id: storageSchoolId,
        ysb_teacher_id: storageTeacher,
        ysb_sub_element_value: ""
      });

      setIsInitialized(true);
    }
  }, [getDataSemester?.id, getDataDimensiDefault?.id, storageBranch, storageSchoolId, storageTeacher, isInitialized]);

  // ✅ FIRST LOAD ONLY: Auto-fetch dashboard dengan default filter
  useEffect(() => {
    if (!isInitialized) {
      console.log('⏸️ Waiting for initialization...');
      return;
    }

    const shouldFetch = 
      form.ysb_semester_id && 
      form.ysb_semester_id !== "" && 
      storageBranch && 
      storageBranch !== "" &&
      storageSchoolId && 
      storageSchoolId !== "" &&
      selectedKelas &&
      selectedKelas !== "" &&
      isFirstLoad &&
      !hasSearched;

    if (shouldFetch) {
      console.log('🚀 First load - auto fetching with default filters...');
      GetResponseData();
      setIsFirstLoad(false);
      setHasSearched(true);
    }
  }, [isInitialized, form.ysb_semester_id, storageBranch, storageSchoolId, selectedKelas, isFirstLoad, hasSearched, GetResponseData]);

  // ✅ Filter complete check (untuk enable/disable button Cari)
  const isFilterComplete =
    isFilterDirty &&
    !!selectedGradeLevel &&
    !!selectedKelas &&
    !!startDate &&
    !!endDate;

  // ✅ HANDLER: Button Cari
  const handleCari = async () => {
    if (!isFilterComplete) {
      swal({
        title: 'Peringatan',
        text: 'Mohon lengkapi filter Tingkatan, Kelas, dan Tanggal terlebih dahulu',
        icon: 'warning',
        timer: 2000,
        buttons: false
      });
      return;
    }

    console.log('🔍 Button Cari clicked - fetching with filters:', {
      gradeLevel: selectedGradeLevel,
      kelas: selectedKelas,
      startDate,
      endDate
    });

    await GetResponseData();
    setHasSearched(true);
  }; 

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      setKeyword(query);
    }, 300); 

    return () => clearTimeout(delayDebounceFn);
  }, [query]);

  // UPDATE NILAI
  const [updateId, setUpdateID] = useState(-1);
  const id_user = localStorage.getItem("id_admin");
  const output_id_user = id_user.replace(/[|&;$%@"<>()+,]/g, "");

  return (
    <div className="body" >

      {/* <div className="body-header d-flex">
        {isTabletOrMobile ? 
          <>
            <div className="title-page">
              <h6><FontAwesomeIcon icon={faListUl}/> Dashboard</h6>
            </div> 
          </>
          : 
          <>
            <div className="title-page">
              <h5><FontAwesomeIcon icon={faListUl}/> Dashboard </h5>
            </div>
          </>
        }   
      </div>  */}

      <div className="page-header-card">
                    <div className="page-header-top d-flex">
                      {isTabletOrMobile ? (
                        <>
                          <div className="page-title-wrap">
                            <span className="page-title-icon">
                              <FontAwesomeIcon icon={faGauge} />
                            </span>
                            <h4 className="page-title-text"> Dashboard</h4>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="page-title-wrap">
                            <span className="page-title-icon">
                              <FontAwesomeIcon icon={faGauge} />
                            </span>
                            <h4 className="page-title-text"> Dashboard</h4>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
      
      
      <div className="body-content">
        {/* Breadcrumnbs */}
        

        {/* FILTER */}
        <Row className="mb-3 align-items-end">
          <Col xs={12} sm={6} md={3} className="mb-3 mb-md-0">
            <label style={{fontSize:12, fontWeight:600, color:'#374151', marginBottom:4, display:'block'}}>Tingkatan</label>
            <select
              className="form-control form-control-sm"
              value={selectedGradeLevel}
              onChange={(e) => {
                const val = e.target.value;
                setSelectedGradeLevel(val);
                const filtered = getDataKelas.filter(k => k.ysb_grade_level_id === val);
                setSelectedKelas(filtered.length > 0 ? filtered[0].id : "");
                setIsFilterDirty(true);
              }}
              style={{ borderRadius: 8 }}
            >
              <option value="" hidden>Pilih Tingkatan</option>
              {getDataGradeLevel.map((g, i) => (
                <option key={i} value={g.id}>{g.name_level}</option>
              ))}
            </select>
          </Col>
          <Col xs={12} sm={6} md={3} className="mb-3 mb-md-0">
            <label style={{fontSize:12, fontWeight:600, color:'#374151', marginBottom:4, display:'block'}}>Kelas</label>
            <select
              className="form-control form-control-sm"
              value={selectedKelas}
              onChange={(e) => { setSelectedKelas(e.target.value); setIsFilterDirty(true); }}
              style={{ borderRadius: 8 }}
            >
              <option value="" hidden>Pilih Kelas</option>
              {getDataKelas
                .filter(k => !selectedGradeLevel || k.ysb_grade_level_id === selectedGradeLevel)
                .map((k, i) => (
                  <option key={i} value={k.id}>{k.name_kelas}</option>
                ))}
            </select>
          </Col>
          <Col xs={12} sm={6} md={2} className="mb-3 mb-md-0">
            <label style={{fontSize:12, fontWeight:600, color:'#374151', marginBottom:4, display:'block'}}>Start Date</label>
            <input
              type="date"
              className="form-control form-control-sm"
              value={startDate}
              onChange={(e) => { setStartDate(e.target.value); setIsFilterDirty(true); }}
              style={{ borderRadius: 8 }}
            />
          </Col>
          <Col xs={12} sm={6} md={2} className="mb-3 mb-md-0">
            <label style={{fontSize:12, fontWeight:600, color:'#374151', marginBottom:4, display:'block'}}>End Date</label>
            <input
              type="date"
              className="form-control form-control-sm"
              value={endDate}
              onChange={(e) => { setEndDate(e.target.value); setIsFilterDirty(true); }}
              style={{ borderRadius: 8 }}
            />
          </Col>
          <Col xs={12} sm={6} md={2}>
            <label style={{fontSize:12, fontWeight:600, color:'#374151', marginBottom:4, display:'block', opacity:0}}>.</label>
            <button
              onClick={handleCari}
              disabled={!isFilterComplete || loading}
              style={{
                width: '100%',
                background: (!isFilterComplete || loading) ? '#94a3b8' : '#eca91aff',
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                padding: '7px 16px',
                fontSize: 13,
                fontWeight: 600,
                cursor: (!isFilterComplete || loading) ? 'not-allowed' : 'pointer',
              }}
            >
              {loading ? 'Mencari...' : 'Cari'}
            </button>
          </Col>
        </Row>

        {loading && <LoaderHome />}

        {/* STATS Cards - Attendance */}
        <Row className="mb-3">
          {/* Card 1 - Blue: Total Siswa */}
          <Col xs={12} sm={6} md={3} className="mb-3 mb-md-0">
            <div style={{position:'relative', background:'#fff', borderRadius:10, padding:18, boxShadow:'0 6px 18px rgba(15,23,42,0.06)', overflow:'hidden'}}>
              <div style={{position:'absolute', left:0, top:0, bottom:0, width:6, background:'#3b82f6', borderRadius:'6px 0 0 6px'}} />
              <div style={{position:'absolute', right:12, top:6, fontSize:64, opacity:0.06, color:'#3b82f6'}}>👥</div>
              <div>
                <div style={{fontSize:11, fontWeight:700, color:'#3b82f6', textTransform:'uppercase', letterSpacing:0.6}}>Total Siswa</div>
                <div style={{fontSize:22, fontWeight:800, color:'#111827', marginTop:6}}>{attendanceStats.total_siswa}</div>
                <div style={{fontSize:12, color:'#6b7280', marginTop:8}}>di jenjang ini</div>
              </div>
            </div>
          </Col>

          {/* Card 2 - Green: Hadir */}
          <Col xs={12} sm={6} md={3} className="mb-3 mb-md-0">
            <div style={{position:'relative', background:'#fff', borderRadius:10, padding:18, boxShadow:'0 6px 18px rgba(15,23,42,0.06)', overflow:'hidden'}}>
              <div style={{position:'absolute', left:0, top:0, bottom:0, width:6, background:'#10b981', borderRadius:'6px 0 0 6px'}} />
              <div style={{position:'absolute', right:12, top:6, fontSize:64, opacity:0.06, color:'#10b981'}}>✅</div>
              <div>
                <div style={{fontSize:11, fontWeight:700, color:'#10b981', textTransform:'uppercase', letterSpacing:0.6}}>Hadir</div>
                <div style={{fontSize:22, fontWeight:800, color:'#111827', marginTop:6}}>{attendanceStats.total_hadir}</div>
                <div style={{fontSize:12, color:'#6b7280', marginTop:8}}>siswa hadir ≥1 hari</div>
              </div>
            </div>
          </Col>

          {/* Card 3 - Red: Alpa */}
          <Col xs={12} sm={6} md={3} className="mb-3 mb-md-0">
            <div style={{position:'relative', background:'#fff', borderRadius:10, padding:18, boxShadow:'0 6px 18px rgba(15,23,42,0.06)', overflow:'hidden'}}>
              <div style={{position:'absolute', left:0, top:0, bottom:0, width:6, background:'#ef4444', borderRadius:'6px 0 0 6px'}} />
              <div style={{position:'absolute', right:12, top:6, fontSize:64, opacity:0.06, color:'#ef4444'}}>❌</div>
              <div>
                <div style={{fontSize:11, fontWeight:700, color:'#ef4444', textTransform:'uppercase', letterSpacing:0.6}}>Alpa</div>
                <div style={{fontSize:22, fontWeight:800, color:'#111827', marginTop:6}}>{attendanceStats.total_alpa}</div>
                <div style={{fontSize:12, color:'#6b7280', marginTop:8}}>siswa alpa ≥1 hari</div>
              </div>
            </div>
          </Col>

          {/* Card 4 - Orange: Sakit */}
          <Col xs={12} sm={6} md={3} className="mb-3 mb-md-0">
            <div style={{position:'relative', background:'#fff', borderRadius:10, padding:18, boxShadow:'0 6px 18px rgba(15,23,42,0.06)', overflow:'hidden'}}>
              <div style={{position:'absolute', left:0, top:0, bottom:0, width:6, background:'#f97316', borderRadius:'6px 0 0 6px'}} />
              <div style={{position:'absolute', right:12, top:6, fontSize:64, opacity:0.06, color:'#f97316'}}>🤒</div>
              <div>
                <div style={{fontSize:11, fontWeight:700, color:'#f97316', textTransform:'uppercase', letterSpacing:0.6}}>Sakit</div>
                <div style={{fontSize:22, fontWeight:800, color:'#111827', marginTop:6}}>{attendanceStats.total_sakit}</div>
                <div style={{fontSize:12, color:'#6b7280', marginTop:8}}>siswa sakit ≥1 hari</div>
              </div>
            </div>
          </Col>

          {/* Card 5 - Yellow: Izin */}
          <Col xs={12} sm={6} md={3} className="mb-3 mb-md-0">
            <div style={{position:'relative', background:'#fff', borderRadius:10, padding:18, boxShadow:'0 6px 18px rgba(15,23,42,0.06)', overflow:'hidden'}}>
              <div style={{position:'absolute', left:0, top:0, bottom:0, width:6, background:'#fbbf24', borderRadius:'6px 0 0 6px'}} />
              <div style={{position:'absolute', right:12, top:6, fontSize:64, opacity:0.06, color:'#fbbf24'}}>📝</div>
              <div>
                <div style={{fontSize:11, fontWeight:700, color:'#fbbf24', textTransform:'uppercase', letterSpacing:0.6}}>Izin</div>
                <div style={{fontSize:22, fontWeight:800, color:'#111827', marginTop:6}}>{attendanceStats.total_izin}</div>
                <div style={{fontSize:12, color:'#6b7280', marginTop:8}}>siswa izin ≥1 hari</div>
              </div>
            </div>
          </Col>

          {/* Card 6 - Purple: Terlambat */}
          <Col xs={12} sm={6} md={3} className="mb-3 mb-md-0">
            <div style={{position:'relative', background:'#fff', borderRadius:10, padding:18, boxShadow:'0 6px 18px rgba(15,23,42,0.06)', overflow:'hidden'}}>
              <div style={{position:'absolute', left:0, top:0, bottom:0, width:6, background:'#8b5cf6', borderRadius:'6px 0 0 6px'}} />
              <div style={{position:'absolute', right:12, top:6, fontSize:64, opacity:0.06, color:'#8b5cf6'}}>⏰</div>
              <div>
                <div style={{fontSize:11, fontWeight:700, color:'#8b5cf6', textTransform:'uppercase', letterSpacing:0.6}}>Terlambat</div>
                <div style={{fontSize:22, fontWeight:800, color:'#111827', marginTop:6}}>{attendanceStats.total_terlambat}</div>
                <div style={{fontSize:12, color:'#6b7280', marginTop:8}}>siswa terlambat ≥1 hari</div>
              </div>
            </div>
          </Col>

          {/* Card 7 - Cyan: % Kehadiran */}
          <Col xs={12} sm={6} md={3} className="mb-3 mb-md-0">
            <div style={{position:'relative', background:'#fff', borderRadius:10, padding:18, boxShadow:'0 6px 18px rgba(15,23,42,0.06)', overflow:'hidden'}}>
              <div style={{position:'absolute', left:0, top:0, bottom:0, width:6, background:'#06b6d4', borderRadius:'6px 0 0 6px'}} />
              <div style={{position:'absolute', right:12, top:6, fontSize:64, opacity:0.06, color:'#06b6d4'}}>📊</div>
              <div>
                <div style={{fontSize:11, fontWeight:700, color:'#06b6d4', textTransform:'uppercase', letterSpacing:0.6}}>Persentase Kehadiran</div>
                <div style={{fontSize:22, fontWeight:800, color:'#111827', marginTop:6}}>{attendanceStats.persentase_kehadiran.toFixed(2)}%</div>
                <div style={{fontSize:12, color:'#6b7280', marginTop:8}}>tingkat kehadiran keseluruhan</div>
              </div>
            </div>
          </Col>
        </Row>

        {/* Charts Section - Hide for now as attendance doesn't need complex charts */}
        {/* Uncomment if you want to add charts later */}

        {/* TABLE: Per-Kelas Attendance Data */}
        {/* <Col xl='12' sm='12'>
          <div className="mt-3" style={{
              background: 'white',
              borderRadius: '12px',
              padding: '20px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
            }}>
            <div className="body-table">
              <div>
                <h6 style={{marginBottom: '15px', color: '#333', fontWeight: 600}}>Daftar Kelas - Rekapitulasi Absensi</h6>
                <div style={{overflowX: 'auto'}}>
                  <table className="table w-100 table-hover table-bordered" id="attendance-table">
                    <thead>
                      <tr>
                        <th style={{textAlign: "center", border: "1px solid #e0e0e0ff", fontWeight: 600}}>Kelas</th>
                        <th style={{textAlign: "center", border: "1px solid #e0e0e0ff", fontWeight: 600}}>Total Siswa</th>
                        <th style={{textAlign: "center", border: "1px solid #e0e0e0ff", fontWeight: 600}}>Hadir</th>
                        <th style={{textAlign: "center", border: "1px solid #e0e0e0ff", fontWeight: 600}}>Sakit</th>
                        <th style={{textAlign: "center", border: "1px solid #e0e0e0ff", fontWeight: 600}}>Izin</th>
                        <th style={{textAlign: "center", border: "1px solid #e0e0e0ff", fontWeight: 600}}>Alpa</th>
                        <th style={{textAlign: "center", border: "1px solid #e0e0e0ff", fontWeight: 600}}>Terlambat</th>
                        <th style={{textAlign: "center", border: "1px solid #e0e0e0ff", fontWeight: 600}}>% Kehadiran</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(attendanceItems || []).length === 0 ? (
                        <tr>
                          <td colSpan={8} style={{textAlign: 'center', padding: '20px', color: '#6b7280'}}>
                            Tidak ada data. Silakan pilih filter dan klik Cari.
                          </td>
                        </tr>
                      ) : (
                        attendanceItems.map((item, idx) => (
                          <tr key={`kelas-${idx}`}>
                            <td style={{ verticalAlign: 'middle' }}>{item.name_kelas || '-'}</td>
                            <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{item.total_siswa || 0}</td>
                            <td style={{ verticalAlign: 'middle', textAlign: 'center', color: '#10b981', fontWeight: 600 }}>{item.total_hadir || 0}</td>
                            <td style={{ verticalAlign: 'middle', textAlign: 'center', color: '#f97316', fontWeight: 600 }}>{item.total_sakit || 0}</td>
                            <td style={{ verticalAlign: 'middle', textAlign: 'center', color: '#fbbf24', fontWeight: 600 }}>{item.total_izin || 0}</td>
                            <td style={{ verticalAlign: 'middle', textAlign: 'center', color: '#ef4444', fontWeight: 600 }}>{item.total_alpa || 0}</td>
                            <td style={{ verticalAlign: 'middle', textAlign: 'center', color: '#8b5cf6', fontWeight: 600 }}>{item.total_terlambat || 0}</td>
                            <td style={{ verticalAlign: 'middle', textAlign: 'center', fontWeight: 600, color: item.persentase_kehadiran >= 75 ? '#10b981' : '#ef4444' }}>
                              {(item.persentase_kehadiran || 0).toFixed(2)}%
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </Col> */}
    </div>
  </div>
  );
}
